import { IBaseResponse } from "@nkr/models/index";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useState } from "react";

interface IRetVal {
    loading: boolean,
    error: string,
    approve: (strongBoxCenterId: number) => void
}

function useStrongBoxAddrApproval(onApproval: () => void): IRetVal {
    const { dispatch } = useAppHookContext();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');

    const approve = async (strongBoxCenterId: number) => {
        setError('');
        setLoading(true);

        let options = {
            url: `${__API__}/strongbox/${strongBoxCenterId}/approve-shipping`
        };

        try {
            const r: IBaseResponse = await dispatch(AuthActionCreators.apiGet(options));

            if (r.data.success) {
                onApproval();
            } else {
                setError('An error occurred while approving this address.');
            }
        } catch (err) {
            setError(`An error occurred while approving this address: ${err}`);
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, approve }
}

export default useStrongBoxAddrApproval;